"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressStatus = void 0;
var AddressStatus;
(function (AddressStatus) {
    AddressStatus["ACTIVE"] = "ACTIVE";
    AddressStatus["INACTIVE"] = "INACTIVE";
})(AddressStatus || (exports.AddressStatus = AddressStatus = {}));
//# sourceMappingURL=address.js.map